import { useClickOutside } from '@starrez/starryui9';
import React, { createRef } from 'react';
import { Manager, Popper, Reference } from 'react-popper';
import { ViewPickerButton } from './components/ViewPickerButton';
import { ViewPickerPanel } from './components/ViewPickerPanel';
import { useViewPicker } from './context/ViewPickerContext';

export const ViewPicker = () => {
    const { isPickerOpen, closePicker } = useViewPicker();
    const containerRef = createRef<HTMLDivElement>();

    useClickOutside(containerRef, () => closePicker());

    return (
        <div>
            <Manager>
                <Reference>
                    {({ ref }) => (
                        <div ref={ref}>
                            <ViewPickerButton />
                        </div>
                    )}
                </Reference>
                {isPickerOpen && (
                    <div ref={containerRef}>
                        <Popper placement="bottom-start" strategy="fixed">
                            {({ ref, style }) => (
                                <div ref={ref} style={{ ...style, zIndex: 2 }}>
                                    <ViewPickerPanel />
                                </div>
                            )}
                        </Popper>
                    </div>
                )}
            </Manager>
        </div>
    );
};
